import React, { Component } from 'react';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
import { Button } from 'reactstrap';
import language from '../../../../assets/languages/language';
import { renderHTMLContent } from '../../../../common/function';
import AppRoutes from '../../../config/AppRoutes';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';

/* eslint-disable*/
class IntroductionInstruction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionsData: [],
      totalCount: 0,
      isLoading: true,
      token: '',
      idname: '',
      startLoading: false,
      strikeThroughArr: [],
    };
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
    };
  };

  changeQuestion = questionNumber => {
    if (questionNumber) {
      this.context.router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_INTRODUCTION)
          .replace(':id', this.props.params.id)
          .replace(':questiono', questionNumber)
          .replace(':timer', this.props.params.timer),
      });
    }
  };

  getPrevious = questionNumber => {
    if (questionNumber) {
      this.context.router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_INTRODUCTION)
          .replace(':id', this.props.params.id)
          .replace(
            ':questiono',
            this.props.params.questiono ? parseInt(this.props.params.questiono) - 1 : 1,
          )
          .replace(':timer', this.props.params.timer),
      });
    }
  };

  getNext = questionNumber => {
    if (questionNumber) {
      this.context.router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_INTRODUCTION)
          .replace(':id', this.props.params.id)
          .replace(
            ':questiono',
            this.props.params.questiono ? parseInt(this.props.params.questiono) + 1 : 1,
          )
          .replace(':timer', this.props.params.timer),
      });
    }
  };

  startTest = () => {
    this.setState({
      startLoading: true,
    });
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
    };
    const userData = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      status: 'pending',
    };
    FD.callAPI(`${App_data.backend_api}/cfaCBTMockExams/getCFAMockQuestions`, data).then(response => {
      if (response.success) {
        this.setState({
          startLoading: true,
        });
        const { question = [] } = response;
        const questionIds = question.map((questionDetail) => questionDetail.id);
        FD.callAPI(`${App_data.backend_api}/cfaCBTMockExams/addUsersChoice`, {...userData, questionIds}).then(
          async res => {
            if (res.success) {
              this.context.router.push({
                pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
                  .replace(':id', this.props.params.id)
                  .replace(
                    ':questiono',
                    response.question && response.question.length ? response.question[0].id : 1,
                  )
                  .replace(':timer', this.props.params.timer)
                  .replace(':testid', res.id)
                  .replace(':offset', 0)
                  .replace(':isNegative', 'true')
                  .replace(':timerStart', 'true'),
              });
            }
          },
        );
      }
    });
  };

  strikeText = (e, value) => {
    e.preventDefault();
    const { strikeThroughArr } = this.state;
    if (e.type === 'contextmenu') {
      strikeThroughArr.push(value);
      this.setState({
        strikeThroughArr: strikeThroughArr,
      });
    } else {
      return;
    }
  };
  render() {
    const { startLoading, strikeThroughArr } = this.state;
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 ques-title-wrapper'>
            <h1 className='section_head'>{language.LC().Section_Introduction}</h1>
          </div>
          <div>
            <div className='row'>
              <div className='qus-tab-wrapper'>
                {Array.from({ length: 12 }, item => item).map((item, index) => {
                  return (
                    <Button
                      key={index}
                      onClick={() => this.changeQuestion(index + 1)}
                      className={`${index + 1 === parseInt(this.props.params.questiono) ? 'active' : ''
                        }`}
                    >
                      {index + 1}
                    </Button>
                  );
                })}
              </div>
              <div className='ques-detail-wrapper col-md-12 question-wrapper intro-wrapper'>
                <div className='card'>
                  {this.props.params.questiono === '1' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().INTROTITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                            {renderHTMLContent(
                              language.LC().INTROPARA,
                              "div",
                              "",
                              { contentEditable: false }
                            )}
                            <h6 className='mt-3'>{language.LC().NEXTTOCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '2' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().WELCOMETITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().WELCOMEPARA, "div", "", { contentEditable: "false" })}
                            <h6 className='mt-3'>{language.LC().NEXTBUTTONCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '3' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().USEMOUSETITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                            <p>
                              <img
                                src={App_data.frontend_url + '/img/questions/icon_arrow.png'}
                                alt='Mouse Arrow'
                              />
                            </p>
                            {renderHTMLContent(language.LC().USEMOUSEPARA, "div", "", { contentEditable: "false" })}
                            <h6 className='mt-3'>{language.LC().NEXTBUTTONCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '4' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().NAVIGATTITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().NAVIGATPARA, "div", "", { contentEditable: "false" })}
                            <p>
                              <img
                                src={App_data.frontend_url + '/img/questions/icon_tab_btn.png'}
                                alt='Mouse Arrow'
                              />
                            </p>
                            {renderHTMLContent(language.LC().NAVIGATBUTTONINFO, "div", "", { contentEditable: "false" })}
                            <h6 className='mt-2'>{language.LC().NEXTBUTTONCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '5' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().TIMEREMAINTITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().TIMEREMAINPARAONE, "div", "", { contentEditable: "false" })}
                            <p>
                              <img
                                className='time-left-img'
                                src={App_data.frontend_url + '/img/questions/img_time.png'}
                              />
                            </p>
                            {renderHTMLContent(language.LC().TIMEREMAINPARATWO, "div", "", { contentEditable: "false" })}
                            <h6 className='mt-3'>{language.LC().NEXTBUTTONCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '6' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().FLAGTITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                            <p>
                              <img
                                src={App_data.frontend_url + '/img/questions/icon_flag_tag.png'}
                              />
                            </p>
                            {renderHTMLContent(language.LC().FLAGPARA, "div", "", { contentEditable: "false" })}
                            <p>
                              <img
                                src={App_data.frontend_url + '/img/questions/icon_flag_tag_btn.png'}
                              />
                            </p>
                            {renderHTMLContent(language.LC().FLAGBUTTON, "div", "", { contentEditable: "false" })}
                            <h6 className='mt-3'>{language.LC().NEXTBUTTONCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '7' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().ANSWERMULTTITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().ANSWERMULTPARA, "div", "", { contentEditable: "false" })}
                          </div>
                          <div className='col-lg-8'>
                            <h6>{language.LC().QUESMULTTITLE}</h6>
                            <div className='answer_box border-black'>
                              <div className='answer_count highlight_choice'>{language.LC().A}</div>
                              <p className='ans_box_text'>
                                <span>{language.LC().ESTONIA}</span>
                              </p>
                            </div>
                          </div>
                          <div className='col-lg-8'>
                            <div className='answer_box border-black'>
                              <div className='answer_count highlight_choice'>{language.LC().B}</div>
                              <p className='ans_box_text'>
                                <span>{language.LC().UKRAINE}</span>
                              </p>
                            </div>
                          </div>
                          <div className='col-lg-8'>
                            <div className='answer_box border-black'>
                              <div className='answer_count highlight_choice'>{language.LC().C}</div>
                              <p className='ans_box_text'>
                                <span>{language.LC().BELGIUM}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '8' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().REVIEWTITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().REVIEWPARA, "div", "", { contentEditable: "false" })}
                            <p>
                              <img
                                width='38px'
                                src={App_data.frontend_url + '/img/questions/icon_menu.png'}
                                alt='Mouse Arrow'
                              />
                            </p>
                            {renderHTMLContent(language.LC().REVIEWPARACLOSE, "div", "", { contentEditable: "false" })}
                            <p>
                              <img
                                className='section-review'
                                src={App_data.frontend_url + '/img/questions/img_sidebar.png'}
                                alt='Mouse Arrow'
                              />
                            </p>
                            <h6 className='mt-3'>{language.LC().NEXTBUTTONCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '9' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().HIGHLIGHTINGTEXT}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().HIGHLIGHTINGPARA, "div", "", { contentEditable: "false" })}
                            <p>
                              <img
                                className='mw-100'
                                src={App_data.frontend_url + '/img/questions/img_highlight.png'}
                                alt='Highlight'
                              />
                            </p>
                            {renderHTMLContent(language.LC().PLEASENOTE, "div", "", { contentEditable: "false" })}
                            <h6 className='mt-3'>{language.LC().NEXTBUTTONCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '10' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().STRIKINGOUTOPTIONS}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().STRIKINGOUTOPTIONSPARA, "div", "", { contentEditable: "false" })}
                            <p>
                              <div className='col-lg-8'>
                                <h6>{language.LC().QUESMULTTITLE}</h6>
                                <div
                                  className='answer_box border-black'
                                  onClick={e => this.strikeText(e, 'choice_a')}
                                  onContextMenu={e => this.strikeText(e, 'choice_a')}
                                >
                                  <div className='answer_count highlight_choice'>
                                    {language.LC().A}
                                  </div>
                                  <p
                                    className={`ans_box_text ${strikeThroughArr.includes('choice_a') ? 'strikethrough' : ''
                                      }`}
                                  >
                                    <span>{language.LC().ESTONIA}</span>
                                  </p>
                                </div>
                              </div>
                              <div className='col-lg-8'>
                                <div
                                  className='answer_box border-black'
                                  onClick={e => this.strikeText(e, 'choice_b')}
                                  onContextMenu={e => this.strikeText(e, 'choice_b')}
                                >
                                  <div className='answer_count highlight_choice'>
                                    {language.LC().B}
                                  </div>
                                  <p
                                    className={`ans_box_text ${strikeThroughArr.includes('choice_b') ? 'strikethrough' : ''
                                      }`}
                                  >
                                    <span>{language.LC().UKRAINE}</span>
                                  </p>
                                </div>
                              </div>
                              <div className='col-lg-8'>
                                <div
                                  className='answer_box border-black'
                                  onClick={e => this.strikeText(e, 'choice_c')}
                                  onContextMenu={e => this.strikeText(e, 'choice_c')}
                                >
                                  <div className='answer_count highlight_choice'>
                                    {language.LC().C}
                                  </div>
                                  <p
                                    className={`ans_box_text ${strikeThroughArr.includes('choice_c') ? 'strikethrough' : ''
                                      }`}
                                  >
                                    <span>{language.LC().BELGIUM}</span>
                                  </p>
                                </div>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '11' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().ENDINGEXAMTITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().ENDINGEXAMPARA, "div", "", { contentEditable: "false" })}
                            <h6 className='mt-3'>{language.LC().NEXTBUTTONCONTINUE}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.props.params.questiono === '12' ? (
                    <div>
                      <div className='card-header d-flex justify-content-between qus-header'>
                        <div className='qus-wrapper'>{language.LC().TUTORIALCONCLUSIONTITLE}</div>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-lg-12'>
                          {renderHTMLContent(language.LC().TUTORIALCONCLUSIONPARA, "div", "", { contentEditable: "false" })}
                            <h6 className='mt-3'>{language.LC().CLICKSTARTTEST}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className='card-block'>
                    <div className='row'>
                      <div className='col-lg-12'>
                        <div className='text-center text-sm-right btm-btn-wrapper'>
                          <Button
                            onClick={this.getPrevious}
                            className='pointer_class btn-primary'
                            disabled={this.props.params.questiono === '1'}
                          >
                            <i className='fa fa-angle-left' /> {language.LC().BACK}
                          </Button>
                          <Button
                            onClick={this.getNext}
                            className='pointer_class btn-primary'
                            disabled={parseInt(this.props.params.questiono) === 12}
                          >
                            {language.LC().NEXT} <i className='fa fa-angle-right' />
                          </Button>
                          <Button
                            onClick={() => {
                              this.startTest();
                            }}
                            className='pointer_class btn-primary'
                          >
                            {startLoading ? <i className='fa fa-spinner fa-spin' /> : ''}{' '}
                            {language.LC().START_TEST} <i className='fa fa-angle-right' />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IntroductionInstruction;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/CFA1CBT/IntroductionInstruction/index.js